import { getScaleFactor, getScreenTop } from 'src/lib/utils';
import uiConfig from 'src/lib/ui/config';
import { View } from '@play-co/timestep-core/ui';
import StateObserver from 'src/StateObserver';
import { Transition, TransitioningScene } from 'src/game/logic/SceneManager';
import { isEntity } from '../logic/EntityManager';
import { createEmitter } from 'src/lib/Emitter';
import { HomeButtonsAnimated } from '../components/HomeButtonsAnimated';

export default abstract class ResponsiveScene implements TransitioningScene {
  public getView = () => this.scene;
  public getIcon(_: string): View | undefined {
    return undefined;
  }

  public getHomeButtons(): HomeButtonsAnimated | undefined {
    return undefined;
  }

  protected onResize?: () => void;

  protected constructor(private scene: View) {
    const initialHeight = scene.style.height;

    scene.on('ViewAdded', () => this.resize());

    scene.once('ViewAdded', () => {
      const { height } = StateObserver.getState().ui.screenSize;
      const heightScalar = height / initialHeight;
      scene.getSubviews().forEach((child) => {
        if (!isEntity(child)) {
          child.style.y *= heightScalar;
        }
      });
    });

    // Listen resize event
    createEmitter(this.scene, ({ ui }) => ui.screenSize).addListener(() => {
      this.resize();
    });
  }

  /**
   * Resize event
   */
  protected resize() {
    const scaleFactor = getScaleFactor();
    const inverseFactor = 1 - scaleFactor;
    const responsiveY = uiConfig.height * inverseFactor * 0.5;

    this.scene.updateOpts({
      width: uiConfig.width,
      height: StateObserver.getState().ui.screenSize.height,
      x: uiConfig.width * inverseFactor * 0.5,
      y: responsiveY,
      offsetY: getScreenTop(),
      clip: true,
    });

    this.onResize?.();
  }

  public onBeforeTransition() {}

  public showScene() {}

  public hideScene() {}

  public prepareScene() {}

  public async preload() {}

  public transition(): Transition {
    return 'fade';
  }

  public pauseScene() {}

  public resumeScene() {}
}
